import styled from 'styled-components';

export const FormComponents = styled.div`
display: flex;
align-items: baseline;

`



